import { Pressable, Text } from "react-native";
import type { StyleProp, TextStyle, ViewStyle } from "react-native";
import { semanticColors } from "../theme/tokens";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

export type TextActionButtonProps = {
  label: string;
  onPress: () => void;
  accessibilityLabel?: string;
  /** Stable analytics identifier, required when `label` is translated. */
  action?: string;
  color?: string;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
};

export function TextActionButton({
  label,
  onPress,
  action,
  accessibilityLabel,
  color = semanticColors.text.secondary,
  disabled = false,
  style,
  textStyle,
}: TextActionButtonProps) {
  const capturePress = usePressCapture("TextActionButton");
  return (
    <Pressable
      onPress={
        disabled
          ? undefined
          : () => {
              capturePress(pressLabel(label, accessibilityLabel), action);
              onPress();
            }
      }
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? label}
      accessibilityState={{ disabled }}
      style={({ pressed }) => [
        {
          paddingVertical: 12,
          paddingHorizontal: 16,
          opacity: disabled ? 0.44 : pressed ? 0.66 : 1,
        },
        style,
      ]}
    >
      <Text
        className="font-dm-sans"
        style={[
          {
            fontSize: 14,
            fontWeight: "600",
            color,
          },
          textStyle,
        ]}
      >
        {label}
      </Text>
    </Pressable>
  );
}

export default TextActionButton;
